// TODO
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser'; 
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Route, Routes, RouterModule, PreloadingStrategy, PreloadAllModules } from '@angular/router';

import { ModulesComponent } from './modules.component';
import { TownSquareComponent } from './modules.townsquare.component';

export const ModuleRoutes = [
  { path: 'modules',                component: ModulesComponent, data: { title: 'Identity Modules' } },
  { path: 'modules/townsquare',     component: TownSquareComponent, data: { title: 'Town Square | Identity RPG' } }
];

@NgModule({ 
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    ModulesComponent,
    TownSquareComponent,
  ],
  imports: [
    BrowserModule,
  	RouterModule.forChild(ModuleRoutes)
  ],
  exports: [ 
    CommonModule,
    RouterModule,
    ModulesComponent,
    TownSquareComponent
   ]
})
export class ModulesModule {}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/modules/modules.module.ts